import { forwardRef } from 'react';

import { IconProps } from '.';

export const StarSolidIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 50 50" fill="currentColor" ref={ref} {...props} {...{ className }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.8701 6.92426C26.7855 4.40563 23.2144 4.40561 22.1297 6.92425L18.3105 15.7928L8.69584 16.6846C5.96531 16.9378 4.86178 20.3341 6.92198 22.1439L14.1763 28.5168L12.0533 37.9364C11.4503 40.6116 14.3394 42.7106 16.6973 41.3105L24.9999 36.3806L33.3025 41.3105C35.6604 42.7106 38.5495 40.6116 37.9466 37.9364L35.8235 28.5167L43.0778 22.1439C45.138 20.3341 44.0345 16.9378 41.304 16.6846L31.6893 15.7928L27.8701 6.92426Z"
      />
    </svg>
  );
});

export default StarSolidIcon;
